import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "FlightsOutlineGreenOnLightGreen__IconWrapper",
  componentId: "sc-1skpnm3-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: themeGet("palette.pricePrimary.dark")(themeProps),
    d: "M22.15.5c.31.004.617.07.902.197a.5.5 0 0 1 .254.254c.126.285.193.591.198.881l-.012.418c-.077 1.384-.803 2.627-2.142 4.081l-.321.341-.68.69-2.084 2.041.428 1.41c.45-.157.968-.103 1.412.186l.127.092 1.397 1.397a1.5 1.5 0 0 1 .386 1.123c-.027.36-.184.696-.411.925l-.102.092-1.269 1.268 1.335 4.404c.124.415.037.861-.23 1.2l-.096.108-.543.543a1.12 1.12 0 0 1-1.734-.146l-.065-.112-4.641-8.528-.625.625-1.263 1.249a20.6 20.6 0 0 1-2.67 2.359l.348 4.502a.84.84 0 0 1-.162.517l-.075.09-.54.54a.87.87 0 0 1-1.327-.115l-.063-.103-1.734-3.45a1.66 1.66 0 0 1-1.125-.208l-.142-.095-.084-.078a1.67 1.67 0 0 1-.374-1.344L.967 16.117a.87.87 0 0 1-.29-1.298l.078-.088.555-.554a.84.84 0 0 1 .499-.218l.12-.003 4.478.355a20.5 20.5 0 0 1 1.94-2.245l.426-.413 1.887-1.898L2.123 5.11a1.12 1.12 0 0 1-.574-.7l-.028-.133a1.12 1.12 0 0 1 .24-.874l.091-.1.547-.546a1.32 1.32 0 0 1 1.165-.355l.14.034 4.402 1.333L9.34 2.54a1.5 1.5 0 0 1 2.068-.251l.124.103 1.422 1.426a1.57 1.57 0 0 1 .238 1.494l1.419.43 2.157-2.214.599-.59.45-.423C19.273 1.19 20.38.574 21.726.511z"
  }), React.createElement("path", {
    fill: themeGet("palette.pricePrimary.light")(themeProps),
    d: "m8.75 18.262.293 3.8-.352.352-1.6-3.184q.144-.067.29-.142.467-.259.92-.54zm8.709-8.07L20.61 20.59l.013.067a.32.32 0 0 1-.048.194l-.043.054-.547.547-.035.027-.037.014-.039.001-.036-.012-.03-.022-.013-.014-4.798-8.816 1.42-1.413zM1.941 14.958l3.798.304q-.297.448-.57.912l-.268.468-.13.267-3.182-1.599zM3.347 3.38l.068.013 10.411 3.154-1.236 1.27-1.195 1.2-8.807-4.792-.04-.027a.12.12 0 0 1-.038-.07.12.12 0 0 1 .013-.073l.022-.03.557-.557.053-.041a.32.32 0 0 1 .192-.047"
  }), React.createElement("path", {
    fill: themeGet("palette.background.lightest")(themeProps),
    d: "m22.141 1.501.136.01.128.021.051.014.027.111.014.103.006.105-.01.316c-.066 1.051-.618 2.053-1.664 3.236l-.216.239-.41.433-.558.562-4.126 4.046-3.257 3.246-.603.594-.386.394a19.6 19.6 0 0 1-4.366 3.275l-.225.111-.234.104-.356.14-.113.027a.7.7 0 0 1-.318-.02l-.096-.04-.039-.025-.028-.038a.66.66 0 0 1-.04-.602c.102-.274.208-.517.327-.753a19.6 19.6 0 0 1 3.292-4.359l.395-.383 4.005-4.026.509-.518 3.371-3.471.236-.237.227-.226.436-.417.244-.225c1.203-1.09 2.117-1.621 3.122-1.725l.202-.015zm-2.66 10.28.091.058 1.333 1.339.042.056a.51.51 0 0 1-.054.595l-.059.057-.93.926-.921-3.04a.57.57 0 0 1 .498.01m-8.704-8.717.065.05 1.363 1.364.042.07c.051.108.06.245.022.376l-.036.096-3.042-.922.891-.89.074-.078a.5.5 0 0 1 .312-.145.5.5 0 0 1 .31.08m10.862-.737a1.186 1.186 0 0 0-1.679 0 .275.275 0 0 0-.001.388.27.27 0 0 0 .384.001.645.645 0 0 1 .745-.12l.088.052.077.065.033.044a.644.644 0 0 1 0 .914.275.275 0 0 0-.002.387.27.27 0 0 0 .384.003 1.194 1.194 0 0 0 .168-1.484l-.078-.11-.088-.098z"
  })));
}
const FlightsOutlineGreenOnLightGreen = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(FlightsOutlineGreenOnLightGreen);
export default Memo;